module.exports = __webpack_public_path__ + "static/img/whitebox.5f995d1e.png";